@if (isLoadingAlternatives) {
  <div class="loading-indicator rematching">
    <div class="loader-container">
      <div class="rematching-loader">
        <div class="pulse-circle"></div>
        <div class="music-notes">
          <span class="note note-1">♪</span>
          <span class="note note-2">♫</span>
          <span class="note note-3">♬</span>
        </div>
      </div>
      <div class="loading-text">Rematching...</div>
    </div>
  </div>
}
@if (!isLoadingAlternatives && showInitialLoading) {
  <div class="loading-state">
    <div class="loading-spinner"></div>
    <p>Loading memories...</p>
  </div>
}
